module.exports = __webpack_public_path__ + "static/media/simplonbp-medium-webfont.6d0ccf74.ttf";